import '../css/Footer.css';
const Footer = ()=>{
    return(
        <>
        <section className="footer_main">
            <p className="footer_desc">&copy; 2024 Soumen Gope, All Right Reserved.</p>
        </section>
        </>
    )
}
export default Footer;